const questionsData = [
  {
    id: 1,
    question: "What is your name?",
    userName: "Ayush Chauhan"
  },
  {
    id: 2,
    question: "How was your placement experience in on campus drive?",
    userName: "Ayush Chauhan"
  },
  {
    id: 3,
    question: "How is your Hostel life going in Galgotias?",
    userName: "Ayush Chauhan"
  },
  {
    id: 4,
    question: "What is your branch name?",
    userName: "Ayush Chauhan"
  }
];

export default questionsData;
